import { Component, forwardRef, HostBinding, Inject, Input, OnInit } from '@angular/core';
import { MSession } from '@argalis-apps/models';
import { AccountConfigService } from '../../../../services/account-config/account-config.service';
import { AuthService } from '../../../../..//auth/services/auth/auth.service';
import { SessionService } from '../../../../services/session/session.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'ags-formation-planning',
  templateUrl: './formation-planning.component.html',
  styleUrls: ['./formation-planning.component.scss']
})
export class FormationPlanningComponent implements OnInit {
  @HostBinding('class') themeFlag: string;

  @Input('idFormation')
  set _idFormation(value: number) {
    this.idFormation = value;
  }
  constructor(
    @Inject(forwardRef(() => AuthService)) private authService: AuthService,
    @Inject(forwardRef(() => AccountConfigService)) private accountConfigService: AccountConfigService,
    private sessionService: SessionService
  ) {}
  public planningInfo: Observable<MSession.IPlanning[]>;
  public idFormation: number;
  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
    if (this.idFormation) {
      this.planningInfo = this.sessionService.getPlanningBySession(this.idFormation);
    }
  }
}
